<template>

  <group-card title="Bank Statement Report" icon="analytics">
    <veda-summary :veda-report="applicant.veda_report" v-if="applicant.veda_report" />
    <md-empty-state
      v-else
      md-icon="highlight_off"
      md-label="Credit file not pulled"
      md-description="Please pull the credit file to view the credit report." >
      <md-button class="md-primary md-sm" @click="get_veda()">Get Veda</md-button>
    </md-empty-state>
  </group-card>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    VedaSummary,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      options: 'options',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async get_veda(){
      try {
        let result = await this.$store.dispatch(
          'request_veda_for_application',
          {
            application_data: this.application,
            applicant_index: this.index,
          }
        );
        this.$emit('application-change');
      } catch (e) {
        console.error(e);
      }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>
